var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-cs-drawer research-data-table-wrapper" },
    [
      _vm.listLoading
        ? _c("div", { staticClass: "vks-ui-status" }, [
            _vm._v("Loading credible sets…"),
          ])
        : _vm.listError
        ? _c("div", { staticClass: "vks-ui-error", attrs: { role: "alert" } }, [
            _vm._v(" " + _vm._s(_vm.listError) + " "),
          ])
        : [
            _c(
              "section",
              {
                staticClass: "vks-drawer-section vks-drawer-section--controls",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "vks-ui-tabs",
                    attrs: {
                      role: "tablist",
                      "aria-label": "Credible sets controls",
                    },
                  },
                  _vm._l(_vm.controlTabs, function (tab) {
                    return _c(
                      "button",
                      {
                        key: tab.id,
                        staticClass: "vks-ui-tab",
                        class: { "is-active": _vm.activeControlTab === tab.id },
                        attrs: {
                          id: `vks-cs-tab-${tab.id}`,
                          type: "button",
                          role: "tab",
                          "aria-selected":
                            _vm.activeControlTab === tab.id ? "true" : "false",
                          "aria-controls": `vks-cs-panel-${tab.id}`,
                        },
                        on: {
                          click: function ($event) {
                            _vm.activeControlTab = tab.id
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(tab.label) + " ")]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeControlTab === "credible-sets",
                        expression: "activeControlTab === 'credible-sets'",
                      },
                    ],
                    staticClass: "vks-ui-tab-panel",
                    attrs: {
                      id: "vks-cs-panel-credible-sets",
                      role: "tabpanel",
                      "aria-labelledby": "vks-cs-tab-credible-sets",
                    },
                  },
                  [
                    _c("div", { staticClass: "vks-cs-select-row" }, [
                      _c(
                        "label",
                        {
                          staticClass: "vks-cs-select-label",
                          attrs: { for: "vks-cs-select" },
                        },
                        [_vm._v(" Select credible set ")]
                      ),
                      _c(
                        "select",
                        {
                          staticClass: "custom-select vks-cs-select",
                          attrs: { id: "vks-cs-select" },
                          domProps: { value: "" },
                          on: { change: _vm.onSelectChange },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Select credible set"),
                          ]),
                          _vm._l(_vm.availableSets, function (entry) {
                            return _c(
                              "option",
                              {
                                key: _vm.optionKey(entry),
                                attrs: { disabled: _vm.isSelected(entry) },
                                domProps: { value: _vm.optionValue(entry) },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.optionLabel(entry)) + " "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm.selectedEntries.length
                      ? _c(
                          "div",
                          { staticClass: "vks-cs-pills" },
                          _vm._l(_vm.selectedEntries, function (entry) {
                            return _c(
                              "button",
                              {
                                key: _vm.selectionKeyForEntry(entry),
                                staticClass: "vks-cs-pill",
                                style: {
                                  backgroundColor:
                                    _vm.colorBySetId[
                                      _vm.selectionKeyForEntry(entry)
                                    ],
                                },
                                attrs: {
                                  type: "button",
                                  title: _vm.pillCountTitle(entry),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.$emit(
                                      "remove-set",
                                      _vm.selectionKeyForEntry(entry)
                                    )
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.pillLabel(entry))),
                                ]),
                                entry.loaded > 0
                                  ? _c(
                                      "span",
                                      { staticClass: "vks-cs-pill-count" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(entry.inRegion) +
                                            "/" +
                                            _vm._s(entry.loaded) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "span",
                                  {
                                    staticClass: "vks-cs-pill-remove",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [_vm._v("×")]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : !_vm.availableSets.length
                      ? _c("p", { staticClass: "vks-ui-status" }, [
                          _vm._v(
                            " No credible sets are available for this locus. "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeControlTab === "filters",
                        expression: "activeControlTab === 'filters'",
                      },
                    ],
                    staticClass: "vks-ui-tab-panel",
                    attrs: {
                      id: "vks-cs-panel-filters",
                      role: "tabpanel",
                      "aria-labelledby": "vks-cs-tab-filters",
                    },
                  },
                  [
                    _vm.activeFilterCount > 1
                      ? _c("div", { staticClass: "vks-cs-filter-reset-row" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-warning btn-sm vks-cs-filter-reset",
                              attrs: { type: "button" },
                              on: { click: _vm.clearAllFilters },
                            },
                            [_vm._v(" Clear all filters ")]
                          ),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "vks-cs-filter-columns" }, [
                      _c("section", { staticClass: "vks-cs-filter-column" }, [
                        _c(
                          "h4",
                          { staticClass: "vks-cs-filter-column-title" },
                          [_vm._v("Variant")]
                        ),
                        _c("div", { staticClass: "vks-cs-filter-field" }, [
                          _c(
                            "label",
                            {
                              staticClass: "vks-cs-filter-label",
                              attrs: { for: "vks-cs-filter-variant" },
                            },
                            [_vm._v(" Variant ID ")]
                          ),
                          _c("input", {
                            staticClass: "form-control vks-cs-filter-input",
                            attrs: {
                              id: "vks-cs-filter-variant",
                              type: "text",
                              list: "vks-cs-filter-variant-list",
                            },
                            domProps: { value: _vm.panelFilters.variantSearch },
                            on: { change: _vm.onVariantSearchChange },
                          }),
                          _c(
                            "datalist",
                            { attrs: { id: "vks-cs-filter-variant-list" } },
                            _vm._l(
                              _vm.variantSearchSuggestions,
                              function (option) {
                                return _c("option", {
                                  key: option,
                                  domProps: { value: option },
                                })
                              }
                            ),
                            0
                          ),
                        ]),
                      ]),
                      _c("section", { staticClass: "vks-cs-filter-column" }, [
                        _c(
                          "h4",
                          { staticClass: "vks-cs-filter-column-title" },
                          [_vm._v("Scores")]
                        ),
                        _c("div", { staticClass: "vks-cs-filter-field" }, [
                          _c(
                            "label",
                            {
                              staticClass: "vks-cs-filter-label",
                              attrs: { for: "vks-cs-filter-ppa" },
                            },
                            [_vm._v(" PPA (>=) ")]
                          ),
                          _c("input", {
                            staticClass: "form-control vks-cs-filter-input",
                            attrs: { id: "vks-cs-filter-ppa", type: "text" },
                            domProps: { value: _vm.panelFilters.ppaMin },
                            on: { change: _vm.onPpaMinChange },
                          }),
                        ]),
                        _c("div", { staticClass: "vks-cs-filter-field" }, [
                          _c(
                            "label",
                            {
                              staticClass: "vks-cs-filter-label",
                              attrs: { for: "vks-cs-filter-pvalue" },
                            },
                            [_vm._v(" P-Value (<=) ")]
                          ),
                          _c("input", {
                            staticClass: "form-control vks-cs-filter-input",
                            attrs: { id: "vks-cs-filter-pvalue", type: "text" },
                            domProps: { value: _vm.panelFilters.pValueMax },
                            on: { change: _vm.onPValueMaxChange },
                          }),
                        ]),
                      ]),
                      _c("section", { staticClass: "vks-cs-filter-column" }, [
                        _c(
                          "h4",
                          { staticClass: "vks-cs-filter-column-title" },
                          [_vm._v("Credible sets")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "vks-cs-filter-checkboxes",
                            attrs: {
                              role: "group",
                              "aria-label": "Selected credible sets",
                            },
                          },
                          _vm._l(_vm.selectedEntries, function (entry) {
                            return _c(
                              "label",
                              {
                                key: _vm.selectionKeyForEntry(entry),
                                staticClass: "vks-cs-filter-check",
                              },
                              [
                                _c("input", {
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: _vm.isFilterSetSelected(
                                      _vm.selectionKeyForEntry(entry)
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.onFilterSetToggle(
                                        _vm.selectionKeyForEntry(entry),
                                        $event
                                      )
                                    },
                                  },
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.pillLabel(entry))),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "section",
              { staticClass: "vks-drawer-section vks-drawer-section--table" },
              [
                _c(
                  "div",
                  { staticClass: "vks-cs-table-section" },
                  [
                    _vm.variantsLoading
                      ? _c("div", { staticClass: "vks-ui-status" }, [
                          _vm._v(" Loading credible variants… "),
                        ])
                      : _vm.variantsError
                      ? _c(
                          "div",
                          {
                            staticClass: "vks-ui-error",
                            attrs: { role: "alert" },
                          },
                          [_vm._v(" " + _vm._s(_vm.variantsError) + " ")]
                        )
                      : _vm.selectedEntries.length
                      ? [
                          _vm.regionFilterNote
                            ? _c("p", { staticClass: "vks-ui-hint" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.regionFilterNote) + " "
                                ),
                              ])
                            : _vm._e(),
                          _vm.filteredTableRows.length
                            ? _c("VariantSifterDataTableView", {
                                attrs: {
                                  rows: _vm.filteredTableRows,
                                  "top-rows": _vm.panelTableColumns,
                                  "table-format": _vm.panelTableFormat,
                                  utils: _vm.utils,
                                  "default-per-page": 10,
                                  "show-star-column": true,
                                  "starred-variant-ids": _vm.starredVariantIds,
                                  "empty-message":
                                    "No credible variants match the current filters.",
                                },
                                on: {
                                  "toggle-star-variant": function ($event) {
                                    return _vm.$emit(
                                      "toggle-star-variant",
                                      $event
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }